import { Outlet, useNavigate } from "react-router-dom";

const AuthLayout = () => {
  const navigate = useNavigate();
  return (
    <div className="flex h-[100vh] justify-between relative">
      <div className="absolute top-[25px] left-[8%]">
        <div className="flex items-center gap-[10px]">
          <div className="h-[50px] ml-[5px]">
            <img
              onClick={() => navigate("/")}
              className="h-full w-full object-cover cursor-pointer"
              src="/logo_noback.png"
              alt="logo"
            />
          </div>
          <div className="leading-[1.2]">
            <p className="text-[28px] font-bold text-[#000000]">Helacred</p>
          </div>
        </div>
      </div>
      <div className="w-[40%] h-full flex items-center justify-end">
        <div className="w-[80%] h-full">
          <Outlet />
        </div>
      </div>
      <div className="w-[60%] h-full bg-[#BFE0FD] flex items-center justify-center">
        <div className="w-[90%]">
          <p className="font-semibold pr-[20px] text-[36px] text-right leading-[1.2] text-[#222222]">
            <span>Effortless</span> management &<br /> <span>Smart</span>&nbsp;
            Insights
          </p>
          <p className="text-[#5C5C5C] text-[20px] mb-[20px] mt-[10px] pr-[20px] text-right">
            Track, onboard, and manage
          </p>
          <div className="w-[100%] rounded-[30px]">
            <img
              className="h-full w-full rounded-[30px] object-cover"
              src="/leftdash2.png"
              alt="auth layer"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;
